// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../CommunityWebPortal/_app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sapphire-dialog[data-v-f7c2c288]{padding:0;border:none;background:none;position:fixed;top:50%;left:50%;transform:translate(-50%, -50%);margin:0}.sapphire-dialog[data-v-f7c2c288]::backdrop{background-color:rgba(0,0,0,.5)}", ""]);
// Exports
module.exports = exports;
